/**
 * @prettier
 * @flow
 */
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { appVersion } from 'src/config/appVersion';
import { translate } from 'src/utils/translate/translate';

const useStyles = makeStyles((theme) => ({
    container: {
        height: '100%',
    },
}));

export function VersionPage() {
    const classes = useStyles();
    return <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        className={classes.container}
    >
        <div className={classes.paper}>
            <Typography variant="subtitle1" align="center" color="textSecondary">
                {translate('App Version')}
            </Typography>
            <Typography variant="h4" align="center" className={classes.header} color="textSecondary">
                {appVersion}
            </Typography>
        </div>
    </Grid>;
}

